import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable} from 'rxjs';
import { getCurrentIdToken } from '../auth.module';
import { AuthService } from '../services/auth.service';
import { switchMap } from 'rxjs/operators';
import { OidcConfig } from "../conf/conf";

/**
 * Propagates the idToken in every Http Request (as a HTTP Header Authorization Bearer)
 */
@Injectable({
    providedIn: 'root'
})
export class JwtInterceptorService implements HttpInterceptor {

    authService = inject(AuthService);
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return this.authService.getToken().pipe(
          switchMap(token => {
            if (token != null) {
              request = request.clone({
                setHeaders: {
                  Authorization: `Bearer ${token}`
                }
              });
            }
            return next.handle(request);
          })
        );
    }
}
